import React, { useState, useEffect } from 'react';
import { HR_managment } from '../../assets';
import { useParams } from 'react-router-dom';

const capitalizeFirstLetter = (str) => {
  if (!str) return ''; 
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase(); 
};
const Page1 = () => {
  const [activeTab, setActiveTab] = useState('sem1');
  
  const { city } = useParams(); 
  const [cityName, setCityName] =  useState(city ? capitalizeFirstLetter(city) : '');

 
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' 
    });
    if (city) {
      setCityName(capitalizeFirstLetter(city)); 
    }
  }, [city]);


  const semesters = {
    sem1: {
      compulsory: [
        'Managerial Accounting',
        'Organizational Behavior',
        'Economics Analysis for Business',
        'Business Research Methodology',
        'Basics of Marketing',
        'Digital Business'
      ],
      electives: [
        {
          note: 'Maximum 3 courses to be selected from the following list',
          subjects: [
            'Management Fundamentals',
            'Indian Economy',
            'Entrepreneurship Development',
            'Essentials of Psychology for Managers',
            'Legal Aspects of Business',
            'Demand Analysis & Forecasting'
          ]
        },
        {
          note: 'Maximum 3 courses to be selected from the following list',
          subjects: [
            'Verbal Communication Lab',
            'Enterprise Analysis & Desk Research',
            'Selling & Negotiation Skills Lab',
            'MS Excel',
            'Business Systems & Procedures',
            'Managing Innovation',
            'Foreign Language – I'
          ]
        }
      ]
    },
    sem2: {
      compulsory: [
        'Marketing Management',
        'Financial Management',
        'Human Resources Management',
        'Operations & Supply Chain Management',
        'Competency Based Human Resource Management',
        'Employee Relations & Labour Legislation'
      ],
      electives: [
        {
          note: 'Any 3 courses to be selected from the following list',
          subjects: [
            'Contemporary Frameworks in Management',
            'Geopolitics & World Economic Systems',
            'Start Up and New Venture Management',
            'Qualitative Research Methods',
            'Business, Government & Society',
            'Business Process Re-engineering'
          ]
        },
        {
          note: 'Maximum 1 course to be selected from the following list',
          subjects: [
            'Written Analysis and Communication Lab',
            'Industry Analysis & Desk Research',
            'Entrepreneurship Lab',
            'SPSS',
            'Foreign Language II'
          ]
        },
        {
          note: 'Maximum 2 courses to be selected from the following list',
          subjects: [
            'Labour Welfare',
            'Lab in Recruitment and Selection',
            'Learning and Development',
            'Public Relations & Corporate Communications',
            'HR Analytics',
            'Conflict and Negotiation Management'
          ]
        }
      ]
    },
    sem3: {
      compulsory: [
        'Strategic Management',
        'Decision Science',
        'Summer Internship Project',
        'Strategic Human Resource Management',
        'HR Operations'
      ],
      electives: [
        {
          note: 'Any 3 courses to be selected from the following list',
          subjects: [
            'International Business Economics',
            'International Business Environment',
            'Project Management',
            'Quality Management',
            'Corporate Governance',
            'Management of Non-profit organizations'
          ]
        },
        {
          note: 'Maximum 3 courses to be selected from the following list',
          subjects: [
            'Talent Management',
            'Psychometric Testing and Assessment',
            'HR Perspectives in Mergers and Acquisition',
            'International HR',
            'Mentoring and Coaching',
            'Compensation and Reward Management'
          ]
        }
      ]
    },
    sem4: {
      compulsory: [
        'Enterprise Performance Management',
        'Indian Ethos & Business Ethics',
        'Organizational Diagnosis & Development',
        'Current Trends & Cases in Human Resource Management'
      ],
      electives: [
        {
          note: 'Any 2 courses to be selected from the following list',
          subjects: [
            'Global Strategic Management',
            'Elective Competing in Global Markets',
            'Elective Cyber Laws',
            'CSR & Sustainability'
          ]
        },
        {
          note: 'Maximum 2 courses to be selected from the following list',
          subjects: [
            'Labour Legislations',
            'Designing HR Policies',
            'Labour Costing',
            'Best Practices in HRM'
          ]
        }
      ]
    }
  };

  return (
    <div className="max-w-7xl mx-auto py-8 px-6">
      <h1 className="text-4xl font-bold text-center mb-6 text-orange-500">{cityName ? `MBA in HR (Human Resource) in ${cityName}` : `MBA in HR (Human Resource)` } </h1>

      {/* About Section */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-4">About MBA in HR (Human Resource)</h2>
        <div>
          <img src={HR_managment} alt="" />
          <p className="text-lg text-gray-700 leading-relaxed">
          Human Resources (HR) or Human Resource Management (HRM) is a continuous process that involves the procurement, development, and maintenance of human resources. The management functions include planning, organizing, directing, and controlling. The main purpose of HRM is to make effective use of employees, reduce risk, and maximize return on investment (ROI).
        </p>

        </div>
        
      </section>

      {/* How We Train */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-4">How We Train</h2>
        <p className="text-lg text-gray-700 mb-4">
          At FBS, HR-specialized students are trained to become successful professionals with in-depth knowledge of Artificial Intelligence (AI), Data Quality, Data Analytics, Statistical Methods, and Data Visualization Models to measure past performance and guide an organization's business planning.
        </p>
        <div className="space-y-4">
          <p className="text-lg text-gray-700">Some of the training methodologies we use include:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Identifying real-world problems across industries and sectors to design effective HR modules and performance management systems (PMS).</li>
            <li>Training on advanced tools like HRMS, HRIS, eNPS, workforce analytics, and 360-degree appraisals.</li>
            <li>Expert-led sessions with corporate professionals and academic specialists in capital markets, fund accounting, risk management, corporate finance, and more.</li>
          </ul>
        </div>
      </section>

      {/* Profile-Oriented Training */}
      <div className="bg-white rounded-lg shadow-md p-6 mb-10">
        <h2 className="text-2xl font-semibold mb-4">Profile-Oriented Training in Human Resources (HR)</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <p className="font-medium text-lg">• Employer Branding Training</p>
            <p className="font-medium text-lg">• Training & Development</p>
            <p className="font-medium text-lg">• PMS Model Training</p>
            <p className="font-medium text-lg">• HR Analytics Training</p>
          </div>
          <div className="space-y-2">
            <p className="font-medium text-lg">• Talent Acquisition</p>
            <p className="font-medium text-lg">• HR Business Partner</p>
            <p className="font-medium text-lg">• Compensation & Reward Management</p>
            <p className="font-medium text-lg">• Labour Law & Industrial Relations</p>
          </div>
        </div>
      </div>

      {/* Why MBA in HR Section */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-4">Why an MBA in Human Resource Management?</h2>
        <p className="text-lg text-gray-700 mb-4">
          As the reliance on data continues to grow, HR jobs are increasing in demand. MBA programs in HR are rising in popularity, and top business schools, including FBS, offer international exposure to meet this global demand. With lucrative salary potential and expanding global opportunities, pursuing an MBA in HR is a rewarding career choice.
        </p>
        <p className="text-lg text-gray-700">
          FBS also offers certifications in Applied Data Science using Python, R, Tableau, SPSS, and Advanced Excel. These certifications, combined with industry-focused training, can help you secure roles such as Human Resources Manager, Technical Recruiter, Compensation Manager, Employee Relations Specialist, and more.
        </p>
      </section>

      {/* Who Should Pursue */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-4">Who Should Pursue an MBA in HR?</h2>
        <p className="text-lg text-gray-700 mb-4">
          Whether you're a BA, B.Com, or BBA graduate, pursuing an MBA in HR at FBS is an excellent way to kickstart your corporate career. Many graduates waste time preparing for competitive exams, but an MBA in HR offers faster career growth and lucrative opportunities in multinational companies.
        </p>
        <p className="text-lg text-gray-700">
          Freshers should stop waiting and enroll today to secure managerial positions in top global companies with a much higher salary than government jobs.
        </p>
      </section>

      {/* Eligibility Criteria */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-4">MBA in HR Eligibility Criteria</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>Completion of education under the 10+2+3 or 10+2+4 system.</li>
          <li>A minimum of 50% aggregate marks in 10th, 12th, and Graduation.</li>
          <li>Qualify through aptitude tests such as CAT, XAT, MAT, CMAT, or FMAT (FBS’s internal aptitude test).</li>
          <li>Work experience adds weight to the application but is not mandatory.</li>
          <li>Applications must be submitted online through our website www.fbs.edu.</li>
        </ul>
      </section>

      {/* Entrance Exam */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-4">MBA in HR Entrance Exam</h2>
        <p className="text-lg text-gray-700">
          To get admitted to FBS's MBA in Human Resource Management, you will need to take the PMAT exam, our internal aptitude test.
        </p>
      </section>

      {/* MBA HR Syllabus and Semesters */}
      <div className="text-center mb-10">
        <h2 className="text-2xl font-semibold mb-4">MBA HR Syllabus</h2>
        <p className="text-lg text-gray-700">
          The syllabus for the MBA HR program is designed to give you a competitive edge in the ever-evolving corporate world. Below are the subjects offered in each semester.
        </p>
      </div>

      <div className="w-full mx-auto p-4">
        <div className="bg-white shadow-lg rounded-lg">
          <div className="border-b">
            <nav className="flex flex-wrap justify-center">
              {['SEMESTER I', 'SEMESTER II', 'SEMESTER III', 'SEMESTER IV'].map((sem, idx) => (
                <button
                  key={idx}
                  onClick={() => setActiveTab(`sem${idx + 1}`)}
                  className={`px-6 py-3 font-medium text-sm transition-colors
                    ${activeTab === `sem${idx + 1}` 
                      ? 'border-b-2 border-blue-500 text-blue-600' 
                      : 'text-gray-500 hover:text-gray-700'}`}>
                  {sem}
                </button>
              ))}
            </nav>
          </div>
        
          <div className="overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-orange-500">
                  <th className="p-4 text-left text-sm font-medium text-gray-600 border">Semester</th>
                  <th className="p-4 text-left text-sm font-medium text-gray-600 border">Subject</th>
                  <th className="p-4 text-left text-sm font-medium text-gray-600 border">Type</th>
                </tr>
              </thead>
              <tbody>
                {/* Compulsory Subjects */}
                <tr>
                  <td className="p-4 border">SEMESTER {activeTab.slice(-1)}</td>
                  <td className="p-4 border">
                    <ul className="list-disc pl-5 space-y-1">
                      {semesters[activeTab].compulsory.map((subject, idx) => (
                        <li key={idx}>{subject}</li>
                      ))}
                    </ul>
                  </td>
                  <td className="p-4 border">Compulsory</td>
                </tr>

                {/* Electives Sections */}
                {semesters[activeTab].electives.map((section, sectionIdx) => (
                  <React.Fragment key={sectionIdx}>
                    <tr>
                      <td colSpan="3" className="p-4 border font-medium text-center bg-gray-50">
                        {section.note}
                      </td>
                    </tr>
                    <tr>
                      <td className="p-4 border">SEMESTER {activeTab.slice(-1)}</td>
                      <td className="p-4 border">
                        <ul className="list-disc pl-5 space-y-1">
                          {section.subjects.map((subject, idx) => (
                            <li key={idx}>{subject}</li>
                          ))}
                        </ul>
                      </td>
                      <td className="p-4 border">Electives</td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Page1;
